var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.text),expression:"text",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopy),expression:"onCopy",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onError),expression:"onError",arg:"error"}],staticClass:"copyable-icon"})
}
var staticRenderFns = []

export { render, staticRenderFns }